<template>
    <div>
        <div class="addEventCoordinator">
            <b-form @submit.prevent="createCoordinators()" class="border-0">

                <!-- Select Event Coordinators -->
                <b-form-group>
                    <div class="enrollFacultyList">
                        <multiselect v-model="selectedCoordinators" tag-placeholder="Add this as new tag"
                            :placeholder="'Choose coordinators for ' + eventModal.name" label="name" track-by="id"
                            :options="facultyOptions" :close-on-select="false" :multiple="true" :taggable="true"
                            @tag="addFaculty" :disabled="actionBtn.disabled"></multiselect>
                    </div>
                </b-form-group>

                <!-- Buttons -->
                <b-form-group>
                    <div class="d-flex justify-content-between flex-wrap">
                        <b-button v-if="selectedCoordinators.length != 0" variant="primary" size="sm"
                            :disabled="actionBtn.disabled" type="submit">
                            {{ actionBtn.text }}
                        </b-button>

                        <b-button variant="danger" size="sm" :disabled="actionBtn.disabled"
                            @click="$emit('addCoordinatorStatus', false)">
                            Cancel
                        </b-button>
                    </div>
                </b-form-group>

            </b-form>
        </div>
    </div>
</template>

<script>
export default {
    props: ["eventModal", "faculties", "eventCoordinatorList"],

    async created() {
        await this.getExistingCoordinators();
        await this.getInstitutionFaculties();
    },

    data() {
        return {
            actionBtn: { text: "Submit", disabled: false },
            selectedCoordinators: [],
            coordinatorsObject: {},
            facultyOptions: [],
        };
    },

    methods: {
        // Prevent showing already added coordinators
        async getExistingCoordinators() {
            this.eventCoordinatorList.forEach((co) => {
                this.$set(this.coordinatorsObject, co.pivot.institution_user_id, true);
            });
        },

        // Create new coordinators
        async createCoordinators() {
            this.actionBtn = { text: "Please wait...", disabled: true };

            let baseUrl = this.$store.getters.getAPIKey.createEventCoordinator;
            let url = baseUrl.replace("event_id", this.eventModal.id);

            const coordinators = {
                institution_users: this.selectedCoordinators.map((co) => co.id),
            };

            await this.$axios
                .post(url, coordinators)
                .then(() => {
                    this.$toast.success(
                        `Event Coordinators added to ${this.eventModal.name}`,
                        { position: "top", duration: 3000 }
                    );

                    this.$emit("fetchcoordinators", true);
                    this.$emit("addCoordinatorStatus", true);
                })
                .catch(() => { })
                .finally(() => {
                    this.actionBtn = { text: "Submit", disabled: false };
                });
        },

        // Tag create option
        addFaculty(newTag) {
            const tag = { name: newTag, id: newTag };
            this.facultyOptions.push(tag);
            this.selectedCoordinators.push(tag);
        },

        // Load faculties except selected coordinators
        async getInstitutionFaculties() {
            this.faculties.forEach((staff) => {
                if (!this.coordinatorsObject[staff.id] && staff.enroll_status === "active") {
                    this.facultyOptions.push({
                        name: `${staff.first_name} ${staff.last_name || ""} ( ${staff.email} )`,
                        id: staff.id,
                    });
                }
            });

            this.facultyOptions.sort((a, b) => a.name.localeCompare(b.name));
        },
    },
};
</script>
